import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getListWithAuthenticated,
  postApiWithAuthenticated,
} from "../ApiMethods/ApiMethod";

const DVRBaseUrl = `${Base_Url}/DailyVisitReport`;

export const GetDailyVisitReportList = async (params) => {
  //
  let url = `${DVRBaseUrl}/GetDailyVisitReportList`;

  const res = await postApiWithAuthenticated(url, params);
  return res;
};
export const AddUpdateDailyVisitReport = async (params) => {
  let url = `${DVRBaseUrl}/AddUpdateDailyVisitReport`;
  try {
    const res = await postApiWithAuthenticated(url, params);
    return res;
  } catch (error) {
    console.error("Error adding appointment:", error);
    throw error; // Rethrow error for handling in the calling function
  }
};

export const GetDailyVisitReportModel = async (id) => {
  let url = `${DVRBaseUrl}/GetDailyVisitReportModel?InvoiceKeyID=${id}`;

  const res = await getListWithAuthenticated(url);
  return res;
};

export const GetDVRModel = async (id) => {
  let url = `${DVRBaseUrl}/GetDailyVisitReportModel?DailyVisitReportKeyID=${id}`;

  const res = await getListWithAuthenticated(url);
  return res;
};
